import { useAppSelector } from 'redux/use-hooks';
import { selectStatusLocalAlert } from 'redux/slices/status';

const useIsSuccessAndError = () => {
  const localAlert = useAppSelector(selectStatusLocalAlert);
  const isLoading =
    !localAlert || localAlert.show === undefined || localAlert.show === false;
  const hasAccountValidationError =
    localAlert && localAlert.show && !localAlert.success;
  const isSuccess = !isLoading && localAlert?.success;
  const isError = !isLoading && hasAccountValidationError;

  return { isLoading, isSuccess, isError };
};

export default useIsSuccessAndError;
